const pageNameKey = "alarmListHeader";

export const alarmListHeaderEn = {
  [pageNameKey]: {
    title: "Name /\n Location",
    condition: "Condition",
    thresholds: "Thresholds /\n Observed Value",
    unit: "Unit",
    active: "Active",
  },
};

export const alarmListHeaderPtBr = {
  [pageNameKey]: {
    title: "Nome /\\n Localização",
    condition: "Condição",
    thresholds: "Limiares /\\n Valor observado",
    unit: "Unidade",
    active: "Ativo",
  },
};

export const alarmListHeaderDe = {
  [pageNameKey]: {
    title: "Name /\n Ort",
    condition: "Zustand",
    thresholds: "Grenzwert /\n Überwachter Wert",
    unit: "Einheit",
    active: "Aktiv",
  },
};

export const alarmListHeaderZhHans = {
  [pageNameKey]: {
    title: "名称 /\n 位置",
    condition: "条件",
    thresholds: "阈值 /\n 观察值",
    unit: "单位",
    active: "活动",
  },
};

export const alarmListHeaderIt = {
  [pageNameKey]: {
    title: "Nome /\n Posizione",
    condition: "Condizione",
    thresholds: "Soglie /\n Valore osservato",
    unit: "Unità",
    active: "Attivo",
  },
};

export const alarmListHeaderEs = {
  [pageNameKey]: {
    title: "Nombre /\n Ubicación",
    condition: "Estado",
    thresholds: "Umbrales /\n Valor observado",
    unit: "Unidad",
    active: "Activo",
  },
};

export const alarmListHeaderNl = {
  [pageNameKey]: {
    active: "Actief",
    condition: "Voorwaarde",
    thresholds: "Drempelwaarden /",
    title: "Naam /",
    unit: "Eenheid",
  },
};

export const alarmListHeaderTr = {
  [pageNameKey]: {
    active: "Aktif",
    condition: "Durum",
    thresholds: "Eşikler /\\n Gözlemlenen Değer",
    title: "Ad /\\n Konum",
    unit: "Birim",
  },
};
